module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("R")]), _vm._v("einhard Heydrich was a high-ranking SS and police official and a main architect of the Holocaust. He was chief of the Reich Main Security Office and became k deputy and acting Reich Protector of Bohemia and Moravia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book, with rare and previously unpublished photographs together with in-depth captions and text, chronicles the story of Heydrich, who later became known as the Butcher of Prague for suppressing Czech culture and deporting and executing members of the Czech Resistance. Brutal and callous, he was directly responsible for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Einsatzgruppen,")]), _vm._v(" the special task forces that travelled in the wake of the German armies, and murdered more than 2 million people by mass shooting and gassing, including 1.3 million Jews. He also chaired the January 1942 Wannsee Conference which formalized plans for the ‘Final Solution to the Jewish Question’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, in May 1942 Heydrich was critically wounded in Prague as a result of Operation ANTHROPOID. Following his assassination, the Nazi State declared a State Funeral in Prague and then another in Berlin. This book reveals unique photos of the funeral held at Hitler’s Reich Chancellery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With Heydrich dead, the Czech people suffered huge reprisals which saw the villages of Lidice and Ležáky razed to the ground and the inhabitants either sent to concentration camps or executed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73ec4dd1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Introduction.vue
// module id = 72
// module chunks = 0